import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const TrafikSigortasiSeo = () => {
 const schema = {
   "@context": "https://schema.org",
   "@type": "Insurance",
   "name": "Trafik Sigortası",
   "description": "En uygun trafik sigortası tekliflerini anında karşılaştırın. 20'den fazla sigorta şirketinden online teklif alın.",
   "aggregateRating": {
     "@type": "AggregateRating", 
     "ratingValue": "4.8",
     "reviewCount": "1250"
   },
   "offers": {
     "@type": "Offer",
     "availability": "https://schema.org/InStock",
     "priceSpecification": {
       "@type": "PriceSpecification",
       "price": "0",
       "priceCurrency": "TRY"
     }
   }
 };

 const faqSchema = {
   "@context": "https://schema.org",
   "@type": "FAQPage",
   "mainEntity": [
     {
       "@type": "Question",
       "name": "Zorunlu trafik sigortası nedir?",
       "acceptedAnswer": {
         "@type": "Answer",
         "text": "Trafik sigortası, karayollarında motorlu araç işletenlerin, bu araçların işletilmesi esnasında üçüncü şahıslara verebilecekleri maddi ve bedeni zararları karşılayan zorunlu bir sigorta türüdür."
       }
     },
     {
       "@type": "Question",
       "name": "2025 trafik sigortası teminat limitleri nelerdir?",
       "acceptedAnswer": {
         "@type": "Answer",
         "text": "2025 yılı için maddi hasar teminat limiti 300.000 TL'dir."
       }
     }
   ]
 };

 const illerFiyat = {
   'İstanbul': {
     basamak8: '5.236 TL',
     basamak7: '6.283 TL',
     basamak6: '8.378 TL',
     basamak5: '9.948 TL',
     basamak4: '11.519 TL',
     basamak3: '15.184 TL',
     basamak2: '19.896 TL',
     basamak1: '24.608 TL',
     basamak0: '31.414 TL'
   },
   'Ankara': {
     basamak8: '5.088 TL',
     basamak7: '6.105 TL',
     basamak6: '8.140 TL',
     basamak5: '9.667 TL',
     basamak4: '11.193 TL',
     basamak3: '14.754 TL',
     basamak2: '19.333 TL',
     basamak1: '23.912 TL',
     basamak0: '30.525 TL'
   },
   'İzmir': {
     basamak8: '4.940 TL',
     basamak7: '5.928 TL',
     basamak6: '7.903 TL',
     basamak5: '9.385 TL',
     basamak4: '10.867 TL',
     basamak3: '14.324 TL',
     basamak2: '18.770 TL',
     basamak1: '23.215 TL',
     basamak0: '29.636 TL'
   },
   'Antalya': {
     basamak8: '4.841 TL',
     basamak7: '5.809 TL',
     basamak6: '7.745 TL',
     basamak5: '9.197 TL',
     basamak4: '10.650 TL',
     basamak3: '14.038 TL',
     basamak2: '18.394 TL',
     basamak1: '22.751 TL',
     basamak0: '29.043 TL'
   },
   'Bursa': {
     basamak8: '5.088 TL',
     basamak7: '6.105 TL',
     basamak6: '8.140 TL',
     basamak5: '9.667 TL',
     basamak4: '11.193 TL',
     basamak3: '14.754 TL',
     basamak2: '19.333 TL',
     basamak1: '23.912 TL',
     basamak0: '30.525 TL'
   }
 };

 return (
   <>         
     <Helmet>
       <title>2025 Trafik Sigortası Fiyatları | SigortamOlsun</title>
       <meta name="description" content="En uygun trafik sigortası fiyatları için hemen online teklif alın! 20+ sigorta şirketinin tekliflerini anında karşılaştırın, %45'e varan indirimlerden yararlanın." />
       <meta name="keywords" content="trafik sigortası, zorunlu trafik sigortası, trafik sigortası fiyatları, trafik sigortası teklifi, trafik sigortası hesaplama" />
       <link rel="canonical" href="https://sigortamolsun.com/trafik-sigortasi" />
       <script type="application/ld+json">
         {JSON.stringify(schema)}
       </script>
       <script type="application/ld+json">
         {JSON.stringify(faqSchema)}
       </script>
     </Helmet>

     <div className="max-w-5xl mx-auto px-4 py-8 md:py-12">

      
       {/* Neden SigortamOlsun */}
       
       <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
       <h2 className="text-2xl font-bold mb-6 text-center">Neden SigortamOlsun.com ?</h2>
         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <div className="flex items-center gap-4 mb-3">
               <span role="img" aria-label="online işlem" className="text-3xl">⚡️</span>
               <h3 className="font-semibold">Uzman Kadro</h3>
             </div>
             <p className="text-gray-600 text-sm">Sigorta sektöründe uzmanlaşmış ekibimizle size en doğru ve en kapsamlı çözümleri sunuyoruz.</p>
           </div>
           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <div className="flex items-center gap-4 mb-3">
               <span role="img" aria-label="en iyi fiyat" className="text-3xl">💰</span>
               <h3 className="font-semibold">İyi Fiyat</h3>
             </div>
             <p className="text-gray-600 text-sm">Sigorta şirketlerinin teklifleri arasında en kapsamlı ve en uygun fiyatı arıyoruz.</p>
           </div>
           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <div className="flex items-center gap-4 mb-3">
               <span role="img" aria-label="güvenli ödeme" className="text-3xl">🔒</span>
               <h3 className="font-semibold">Güvenli</h3>
             </div>
             <p className="text-gray-600 text-sm">Güvenliğiniz bizim için öncelikli.</p>
           </div>
         </div>
       </section>

      {/* Trafik Sigortası Bilgilendirme */}
<section className="mb-12">
 <h2 className="text-2xl font-bold mb-6">Zorunlu Trafik Sigortası</h2>
 <div className="prose max-w-none space-y-8">
   <div>
     <h3 className="text-xl font-semibold mb-3">Trafik Sigortası Nedir?</h3>
     <p>
     Trafik sigortası, tüm araç sahiplerinin yaptırması gereken zorunlu bir sigortadır. Eğer kaza yaparsanız, karşı tarafın araç hasarı, yaralanma ve tedavi masraflarını bu sigorta karşılar. Trafik sigortası olmadan aracınızı kullanırsanız polis veya jandarma kontrol noktalarında aracınız bağlanır ve ceza ödersiniz. Üstelik sigortayı yaptırmak istediğinizde de cezalı prim ödemek zorunda kalırsınız. Bu yüzden hem kendinizi hem de trafikteki diğer insanları korumak için trafik sigortanızı mutlaka yaptırmalı ve süresini düzenli takip etmelisiniz.
     </p>
   </div>

   <div>
     <h3 className="text-xl font-semibold mb-3">Trafik Sigortası Fiyatı Öğrenmek İstiyorum</h3>
     <p>
       sigortamolsun.com sigorta acenteliği ile en uygun trafik sigortası tekliflerini öğrenebilirsin. 10'dan fazla sigorta şirketinin teklifleri arasında, size en uygun poliçeyi seçebilirsiniz.
     </p>
   </div>

   <div>
     <h3 className="text-xl font-semibold mb-3">Trafik Sigortası Fiyatları Nasıl Hesaplanır?</h3>
     <p>
       Trafik sigortası primi hesaplanırken öncelikli olarak sürücünün hasarsızlık basamağı dikkate alınır. Sonrasında ise aracınızın yaşı, markası, modeli ve trafiğe kayıtlı olduğu il gibi faktörler göz önünde bulundurulur. Aynı zamanda sürücü yaşı trafik sigortası fiyatını etkileyen önemli unsurlardır. Kişi adına ilk araç alıyor ise 4.basamaktan başlar. Hasarsız geçirdiği her yıl bir basamak yukarı çıkar ve indirim kazanır.
     </p>
   </div>
 </div>
</section>

       {/* Trafik Sigortası Fiyatları */}
       <section className="mb-12">
         <h2 className="text-2xl font-bold mb-6">2025 Trafik Sigortası İl Bazlı Ortalama Fiyatlar</h2>
         <div className="overflow-x-auto">
           <table className="min-w-full bg-white border border-gray-200 shadow-sm rounded-lg">
             <thead>
               <tr className="bg-gray-50">
                 <th className="px-4 py-3 border-b text-left text-sm font-semibold text-gray-600">İl</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">8. Basamak<br/>(%50 indirim)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">7. Basamak<br/>(%40 indirim)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">6. Basamak<br/>(%20 indirim)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">5. Basamak<br/>(%5 indirim)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">4. Basamak<br/>(%10 artırım)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">3. Basamak<br/>(%45 artırım)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">2. Basamak<br/>(%90 artırım)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">1. Basamak<br/>(%135 artırım)</th>
                 <th className="px-4 py-3 border-b text-right text-sm font-semibold text-gray-600">0. Basamak<br/>(%200 artırım)</th>
               </tr>
             </thead>
             <tbody>
               {Object.entries(illerFiyat).map(([il, fiyatlar]) => (
                 <tr key={il} className="hover:bg-gray-50">
                   <td className="px-4 py-3 border-b font-medium">{il}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak8}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak7}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak6}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak5}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak4}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak3}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak2}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak1}</td>
                   <td className="px-4 py-3 border-b text-right">{fiyatlar.basamak0}</td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>

         <p className="text-sm text-gray-500 mt-4">
    2025 yılı ortalama fiyatlarıdır. Fiyatlar sigorta şirketlerine, aracın bulunduğu ile ve teminatlara göre değişiklik gösterebilir.
  </p>
       </section>

{/* Trafik Sigortası Teminatları */}
<section className="mb-12">
  <h2 className="text-2xl font-bold mb-6">Trafik Sigortası Teminat Limitleri</h2>
  <div className="overflow-x-auto">
    <table className="min-w-full bg-white border border-gray-200 shadow-sm rounded-lg">
      <thead>
        <tr className="bg-gray-50">
          <th className="px-4 py-3 border-b text-left text-sm font-semibold text-gray-600">Araç Grubu</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600" colSpan="2">Sağlık Gideri</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600" colSpan="2">Sakatlanma ve Ölüm</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600" colSpan="2">Maddi Zararlar</th>
        </tr>
        <tr className="bg-gray-50">
          <th className="px-4 py-3 border-b text-left text-sm font-semibold text-gray-600"></th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Kişi Başına</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Kaza Başına</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Kişi Başına</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Kaza Başına</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Araç Başına</th>
          <th className="px-4 py-3 border-b text-center text-sm font-semibold text-gray-600">Kaza Başına</th>
        </tr>
      </thead>
      <tbody>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Otomobil<br/></td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">13.500.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">13.500.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Kamyonet, Kamyon, Minibüs veya Çekici<br/></td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">27.000.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">27.000.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Tarım Araçları ile Özel Amaçlı Araçlar</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">13.500.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">13.500.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Motosiklet ve Yük Motosikleti</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">8.100.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">8.100.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Minibüs<br/>(sürücü dahil 10-17 koltuk)</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">6.075.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">6.075.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Otobüs<br/>(sürücü dahil 18-30 koltuk)</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">15.795.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">15.795.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
        <tr className="hover:bg-gray-50">
          <td className="px-4 py-3 border-b font-medium">Otobüs<br/>(sürücü dahil 31+üstü koltuk)</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">31.590.000 TL</td>
          <td className="px-4 py-3 border-b text-center">2.700.000 TL</td>
          <td className="px-4 py-3 border-b text-center">31.590.000 TL</td>
          <td className="px-4 py-3 border-b text-center">300.000 TL</td>
          <td className="px-4 py-3 border-b text-center">600.000 TL</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

 {/* SSS */}
 <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
 <h2 className="text-2xl font-bold mb-6">Trafik Sigortası Hakkında Sıkça Sorulan Sorular</h2>
  <div className="space-y-6">
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası Neleri Kapsar?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası, kaza durumlarında karşı tarafın ve üçüncü kişilerin hasarlarını kapsar. Maddi zararlar, bedeni hasarlar, tedavi masrafları teminat altındadır. Ayrıca kamu mallarına verilen zararlar da sigorta kapsamındadır.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası Teminat Limitleri Nedir?</h3>
      <p className="text-gray-600 text-sm">
        2025 Yılı İçin Teminat limitleri: Maddi hasarlarda araç başına 300.000 TL, kaza başına 600.000 TL; sağlık giderlerinde kişi başına 2.700.000 TL; sakatlanma ve ölüm durumunda kişi başına 2.700.000 TL, kaza başına 13.500.000 TL olarak belirlenmiştir.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası ve Kasko Farkı Nedir?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası zorunludur ve karşı tarafın zararlarını karşılar. Kasko isteğe bağlıdır ve kendi aracınızın hasarlarını kapsar. Kasko, park halindeki hasarlar ve doğal afet zararlarını da teminat altına alır.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası İptal Olur mu?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası üç durumda iptal edilebilir: aracın satışı, ruhsat sahibinin vefatı veya aracın trafikten çekilmesi durumunda. Bunlar dışında sigortasız araç kullanımı yasaktır.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Hasarsızlık İndirimi Nedir?</h3>
      <p className="text-gray-600 text-sm">
        Hasarsızlık indirimi, sigorta süresince kaza yapmayan sürücülere sunulan bir avantajdır. Hasarsız geçen her yıl için bir sonraki poliçede indirim uygulanır. Kaza durumunda ise prim tutarı yükselir.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası Süresi Ne Kadardır?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası poliçe süresi 1 yıldır. Süre sonunda poliçenin yenilenmesi gerekir. Sigortasız araç kullanımı durumunda para cezası uygulanır ve araç bağlanır.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası Yaptırmamanın Cezası Nedir?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası olmadan araç kullanmak yasaktır. Tespit edilmesi durumunda kolluk kuvvetleri tarafından araç bağlanır ve cezalı prim ödenmesi gerekir.
      </p>
    </div>

    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="font-semibold mb-3">Trafik Sigortası Doğal Afet Hasarlarını Karşılar mı?</h3>
      <p className="text-gray-600 text-sm">
        Trafik sigortası doğal afet hasarlarını karşılamaz. Bu tür zararların karşılanması için kasko sigortası yaptırılması gerekir.
      </p>
    </div>
  </div>
</section>

       {/* Müşteri Yorumları */}
       <section className="mb-12">
         <h2 className="text-2xl font-bold mb-6">Müşteri Yorumları</h2>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <div className="flex items-start gap-4">
               <div className="flex-shrink-0">
                 <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                   <span className="text-blue-600 font-semibold">AY</span>
                 </div>
               </div>
               <div>
                 <h3 className="font-semibold">Ahmet Y.</h3>
                 <div className="flex text-yellow-400 mb-2">★★★★★</div>
                 <p className="text-gray-600 text-sm">
                   "Sigorta müşteri temsilcim ile en uygun fiyatlı poliçeyi satın aldım. Çok pratikler. Teşekkürler."
                 </p>
               </div>
             </div>
           </div>
           <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <div className="flex items-start gap-4">
               <div className="flex-shrink-0">
                 <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                   <span className="text-blue-600 font-semibold">MK</span>
                 </div>
               </div>
               <div>
                 <h3 className="font-semibold">Yasemin K.</h3>
                 <div className="flex text-yellow-400 mb-2">★★★★★</div>
                 <p className="text-gray-600 text-sm">
                   "Birden fazla sigorta şirketleri ile çalışıyorlar. Zamandan tasarruf ettim. En uygun fiyatı buldum."
                 </p>
               </div>
             </div>
           </div>
         </div>
       </section>

       {/* İlgili Sigortalar */}
       <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
         <h2 className="text-2xl font-bold mb-6">İlgili Sigortalar</h2>
         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
           <Link to="/kasko" className="block bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition">
             <h3 className="font-semibold mb-2">Kasko Sigortası</h3>
             <p className="text-gray-600 text-sm">Aracınızı kapsamlı güvence altına alın.</p>
           </Link>
           <Link to="/dask" className="block bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition">
             <h3 className="font-semibold mb-2">DASK</h3>
             <p className="text-gray-600 text-sm">Zorunlu deprem sigortası ile evinizi koruyun.</p>
           </Link>
         </div>
       </section>

       {/* Faydalı Bilgiler */}
       <section>
         <h2 className="text-2xl font-bold mb-6">Faydalı Bilgiler</h2>
         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
           <article className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <h3 className="font-semibold mb-3">Trafik Sigortasında Dikkat Edilmesi Gerekenler</h3>
             <p className="text-gray-600 text-sm mb-4">
               Trafik sigortası yaptırırken dikkat etmeniz gereken önemli noktaları derledik.
             </p>
             <Link to="/blog/trafik-sigortasi-ipuclari" className="text-blue-600 text-sm hover:underline">
               Devamını Oku →
             </Link>
           </article>
           <article className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
             <h3 className="font-semibold mb-3">2025 Trafik Sigortası Değişiklikleri</h3>
             <p className="text-gray-600 text-sm mb-4">
               2025 yılında trafik sigortasında yapılan tüm değişiklikleri öğrenin.
             </p>
             <Link to="/blog/trafik-sigortasi-degisiklikler-2024" className="text-blue-600 text-sm hover:underline">
               Devamını Oku →
             </Link>
           </article>
         </div>
       </section>
       

     </div>
     <Footer />
   </>
 );
};

export default TrafikSigortasiSeo;